/** 
*@author: satyamurthy.a
*@Description : 
**/
import { connect } from 'react-redux';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { Input, Popconfirm, Tooltip, Button } from 'antd';
import { constant } from '../../../Utils/constants';
import React, { useEffect, useState, useRef } from 'react';
import localStorage from '../../../../../utils/localStorage';
import translation from '../../../../../commons/translation';

import { API_CONDITIONALMONITORING } from '../../../../../commons/api';
import { deleteById, getConditionMoitorList } from '../../../Utils/FormCalls';
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  SearchOutlined
} from '@ant-design/icons';

const CMList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [userProfile, setUserProfile] = useState(props.userProfile || {});
  // const [userList, setUserList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  let config = {
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['Name', 'Description'],
    firstTitle: 'Name',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/CMDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {

    _getDataSource();
  }, []);

  useEffect(() => {
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
    }
  }, [props.userProfile]);

  const deleteCM = async (id) => {
    const siteId = localStorage.get('currentSite');
    let payload = {
      url: `${API_CONDITIONALMONITORING.DELETE}?Id=${id}&SiteId=${siteId}`,
      method: 'POST'
    };
    await deleteById(payload);
    await _getDataSource();
  };

  const edit = (record) => {
    props.navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  // const _getUserList = async () => {
  //   let userList = await getUsersList();
  //   setUserList(userList);
  // };

  const _getDataSource = async () => {
    let dataSource = await getConditionMoitorList();
    setDataSource(dataSource);
  };

  const _deleteById = async (id) => {
    const siteId = localStorage.get('currentSite');
    let payload = {
      url: `${API_CONDITIONALMONITORING.DELETE}?Id=${id}&SiteId=${siteId}`,
      method: 'POST'
    };
    await deleteById(payload);
    let dataSource = await getConditionMoitorList();
    setDataSource(dataSource);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <SearchOutlined
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 90, marginRight: 8, }}
        />
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const handleRowClick = (ruleId) => {
    props.navigate(`/rubus/CmFeedback/?cmId=${ruleId}`);
  };

  const { translationCache } = props;
  const columns = [
    {
      title: translation(translationCache, constant.name),
      dataIndex: 'Name',
      key: 'Name',
      ...getColumnSearchProps('Name')
    },
    {
      title: translation(translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(translationCache, constant.site),
      dataIndex: 'SiteId',
      key: 'SiteId'
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button
            style={{ marginRight: '5px' }}
            onClick={() => edit(record)}
          >
            <Tooltip title={translation(translationCache, 'Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={translation(
              translationCache,
              constant.areYouSureThatYouWantToDelete
            )}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => deleteCM(record.Id)}
            okText="Yes"
            cancelText="No"
          >
            <Button style={{ marginRight: '5px' }}>
              <Tooltip title={translation(translationCache, 'Delete')}>
                <DeleteOutlined />
              </Tooltip>
            </Button>
          </Popconfirm>
          <Button
            onClick={() => handleRowClick(record.Id)}
          >
            {translationCache && translationCache[`Notification History`]
              ? translationCache[`Notification History`]
              : `Notification History`}
          </Button>
        </>
      )
    }
  ];
  config = {
    title: translation(translationCache, 'Conditional Monitoring'),

    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',

    filterType: 'ByAttributeValue',
    attributeList: ['Name'],

    firstTitle: 'Name',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',

    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/CMDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };
  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        // userList={userList}
        config={config}
        delete={_deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile
});

export default connect(mapStateToProps)(CMList);